import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";
class RayicExportPdfAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "Rapor/GetTapuRayicRapor";
        super(baseUrl);
    }

    geExportPdfListe(enRequest: IEnRayicRequest) {

        //var request = new ExportPdfListeRequest(sqId);
        return this.post("", enRequest, true);
    }
}
export default new RayicExportPdfAPI();
class ExportPdfListeRequest {
    public sqId: string;

    constructor(sicilKodu: string) {

        this.sqId = sicilKodu;

    }
}

interface IEnRayicRequest {
    sqId: string
}
export { ExportPdfListeRequest };    export type { IEnRayicRequest };

